// Copyright © 2024 Broadcom Inc. and its subsidiaries. All Rights Reserved.
import * as constants from '../../constants';
import { getConfig } from '../../reducers/portalConfig';
import { getValidationErrors } from '../../utils';
import axios from 'axios';

export const registerUser = (payload) =>
  async (dispatch, getState) => {
    dispatch({
      type: constants.REGISTER_REQUEST,
      loading: true,
    })
    const config = getConfig(getState());
    const { portal } = config;

    const url = `${portal?.hostname}/api/${portal?.tenantPrefix}/v2/users/registrations`;
    await axios.post(url, payload, { credentials: 'include' })
      .then((response) => {
        dispatch({
          type: constants.REGISTER_SUCCESS,
          payload: response.data,
        });
      })
      .catch((error) =>
        dispatch({
          type: constants.REGISTER_ERROR,
          error: getValidationErrors(error),
        }),
      );
  };
